import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as createUnavailability from "./createUnavailability";
import * as retrieveUnavailabilityReasons from "./retrieveUnavailabilityReasons";
import * as retrieveUnavailabilities from "./retrieveUnavailabilities";
import * as editUnavailability from "./editUnavailability";
import * as removeUnavailability from "./removeUnavailability";

const initialState: State = {
  createUnavailability: createUnavailability.initialState,
  retrieveUnavailabilityReasons: retrieveUnavailabilityReasons.initialState,
  retrieveUnavailabilities: retrieveUnavailabilities.initialState,
  editUnavailability: editUnavailability.initialState,
  removeUnavailability: removeUnavailability.initialState,
};

const reduceState = combineStateReducer(initialState, {
  createUnavailability: createUnavailability.reduceState,
  retrieveUnavailabilityReasons: retrieveUnavailabilityReasons.reduceState,
  retrieveUnavailabilities: retrieveUnavailabilities.reduceState,
  editUnavailability: editUnavailability.reduceState,
  removeUnavailability: removeUnavailability.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...createUnavailability.createSelector(
      () => getState().createUnavailability,
    ),
    ...retrieveUnavailabilityReasons.createSelector(
      () => getState().retrieveUnavailabilityReasons,
    ),
    ...retrieveUnavailabilities.createSelector(
      () => getState().retrieveUnavailabilities,
    ),
    ...editUnavailability.createSelector(() => getState().editUnavailability),
    ...removeUnavailability.createSelector(
      () => getState().removeUnavailability,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
